import { AnalyticsEventName } from './analytics-event-name.model';
import { AnalyticsEventModel } from './analytics-event.model';

export interface AnalyticsEventDataModel {
  name: AnalyticsEventName;
  event: AnalyticsEventModel;
}
